import { Candidate } from '$synapse/models';
import { GroupDTO } from './group-dto';
import { ExamDTO, mapToExam } from './exam-dto';

export interface CandidateDTO {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdDate: Date;
  groups: GroupDTO[];
  exams: ExamDTO[];
}

export function mapToCandidate(dto: CandidateDTO): Candidate {
  const exams = dto.exams ? dto.exams.map(mapToExam) : [];
  return {
    ...dto,
    exams,
  };
}
